import type {
  KeyboardNavigationInput,
  KeyboardNavigationDirection,
} from './enums'
import type { KeyboardNavigationFocusPosition } from './types'

export type KeyboardNavigationColumn = string

export enum KeyboardNavigationEvent {
  JUMP = 'jump',
  FOCUS = 'focus',
}

export type KeyboardNavigationJumpPayload = {
  direction: KeyboardNavigationDirection
  fromCueId: string
  fromColumnId: KeyboardNavigationColumn
  fromInputType: KeyboardNavigationInput
}

export type KeyboardNavigationFocusPayload = {
  focusPosition: KeyboardNavigationFocusPosition
  cueId: string
  columnId: KeyboardNavigationColumn
  inputType: KeyboardNavigationInput
}

export type KeyboardNavigationEvents = {
  [KeyboardNavigationEvent.JUMP]: KeyboardNavigationJumpPayload
  [KeyboardNavigationEvent.FOCUS]: KeyboardNavigationFocusPayload
}
